import useSubscriptionPlansHelpers from '~/pages/subscriptions/hooks/useSubscriptionPlansHelpers';
import PopUp from '~/shared/SubsPopUps/PopUp';
import PopUpBanner from '~/shared/SubsPopUps/PopUpBanner';
import { useI18n } from '@springbig/shared';
import React, { useEffect } from 'react';
import { Box } from 'native-base';
import { useAppNavigate } from '~/pages';
import { addYears, addHours } from 'date-fns';

type PopUpContainerProps = {
    onClose: () => void;
};

const PopUpContainer = ({ onClose }: PopUpContainerProps) => {

    const { navigate, params } = useAppNavigate();
    const { t } = useI18n();

    const {
        hasWarning,
        showSubPrompt,
    } = useSubscriptionPlansHelpers();

    useEffect(() => {

        if (showSubPrompt) {
            localStorage.setItem(
                'last_shown_subs_prompt',
                JSON.stringify(new Date())
            );
        }
    }, [showSubPrompt]);

    const onHandleProceed = () => {

        if (showSubPrompt) {
            localStorage.setItem(
                'last_shown_subs_prompt',
                JSON.stringify(
                    addHours(new Date(), 2)
                )
            );
        }

        navigate(`w/${params.wallet_id}/subscriptions`);
        onClose();
    };

    const onHandleDismiss = () => {

        if (showSubPrompt) {
            localStorage.setItem(
                'last_shown_subs_prompt',
                JSON.stringify(addYears(new Date(), 1))
            );
        }

        onClose();
    };

    const onHandleCancel = () => {

        onClose();
    };

    return (
        <Box>
            { showSubPrompt &&
                <PopUp
                    title={t('subscriptions.popups.sub_prompt.title')}
                    button={t('subscriptions.popups.sub_prompt.button')}
                    onProceed={onHandleProceed}
                />
            }
            { hasWarning &&
                <PopUpBanner
                    title={t('subscriptions.popups.failed_payment.title')}
                    description={t('subscriptions.popups.failed_payment.text')}
                    button={t('subscriptions.popups.failed_payment.button')}
                    isDismissable={showSubPrompt}
                    onProceed={onHandleProceed}
                    onDismiss={onHandleDismiss}
                    onCancel={onHandleCancel}
                />
            }
        </Box>
    );
};

export default PopUpContainer;
